import { CpmSkeletonRow } from '../../../components/design-system';

export default function TemplatesListSkeleton({ rows = 7 }: { rows?: number }) {
    return (
        <div
            className="rounded-[16px] border-[1.5px] border-[var(--cpm-border-default)] bg-white overflow-hidden"
            aria-busy="true"
            aria-label="Loading templates"
        >
            {Array.from({ length: rows }).map((_, index) => (
                <CpmSkeletonRow key={index} index={index} />
            ))}
        </div>
    );
}
